import {
    SET_DIGITAL_SERVICE_COMMENT_QUESTION1,
    SET_DIGITAL_SERVICE_COMMENT_QUESTION2,
} from '../actions/digitalServiceAction';

const initialState = {
    question1Comment: '',
    question2Comment: '',
};

const digitalServiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DIGITAL_SERVICE_COMMENT_QUESTION1:
            return {
                ...state,
                question1Comment: action.payload,
            };
        case SET_DIGITAL_SERVICE_COMMENT_QUESTION2:
            return {
                ...state,
                question2Comment: action.payload,
            };
        default:
            return state;
    }
};

export default digitalServiceReducer;
